import { FC } from "react";
import { Alert, Card, Col, Row } from "antd";
import { useNavigate } from "react-router-dom";
import ParcelListTab from "./ParcelList/ParcelListTab";
import ManageParcelPageHeader from "./ParcelShared/ManageParcelPageHeader";
import { useParcelMerchantGate } from "./ParcelShared/useParcelMerchantGate";
import { MANAGE_PARCEL_LIST_PATH } from "./ParcelShared/parcelRoutes";

const ManageParcelList: FC = () => {
  const navigate = useNavigate();
  const { hasMerchant, loading } = useParcelMerchantGate();

  if (loading) {
    return null;
  }

  return (
    <Card bordered={false} className="criclebox h-full tabs-mobile">
      <ManageParcelPageHeader
        title="ส่งพัสดุทั่วไป"
        onBack={() => navigate("/setting")}
      />
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col sm={24} md={24}>
          {!hasMerchant ? (
            <Alert
              type="warning"
              showIcon
              message="ยังไม่ได้ตั้งค่าจุดรับสินค้า"
              description="ยังไม่ได้ตั้งค่าจุดรับสินค้าาสำหรับร้านค้าของคุณ กรุณาตั้งค่าจุดรับสินค้าก่อนสร้างรายการส่งพัสดุ"
            />
          ) : (
            <ParcelListTab />
          )}
        </Col>
      </Row>
    </Card>
  );
};

export default ManageParcelList;
